import { AnyAction } from 'redux';
import { isEmpty, reject, union } from 'lodash/fp';

import { AppDispatch } from '../../store/types';
import { RootState } from '../../reducers';
import getSaleableCombinedProductIds from '../../utils/get-saleable-combined-product-ids';
import getSaleableProductIds from '../../utils/get-saleable-product-ids';
import ProductActions from '../../actions/product';
import ProductService from '.';
import type { ProductType } from '../../types/product';

const fetchAllProductData = (
  state: Pick<RootState, 'product'>,
  dispatch: AppDispatch,
  withCombinedProducts?: boolean,
  selectedProductIds?: ProductType['id'][],
) => {
  const products = state.product.data;

  const saleableProductIds =
    withCombinedProducts === true
      ? union(getSaleableProductIds(), getSaleableCombinedProductIds())
      : getSaleableProductIds();

  const selectedSaleableProductIds =
    Array.isArray(selectedProductIds) && selectedProductIds.length > 0
      ? selectedProductIds.filter((productId) => saleableProductIds.includes(productId))
      : saleableProductIds;

  const productIdsToLoad = reject(
    (productId) => ProductService.getProduct(products, productId),
    selectedSaleableProductIds,
  );

  if (isEmpty(productIdsToLoad)) {
    return Promise.resolve();
  }

  // Cast required: ProductActions.load returns a promise middleware action ({ types, promise })
  // rather than a standard Redux action ({ type }). The promise middleware intercepts it before Redux.
  const action = ProductActions.load(productIdsToLoad) as unknown as AnyAction;
  return dispatch(action);
};

export default fetchAllProductData;
